import React, { useState } from 'react';
import '../css/VendorProductForm.css';
import { API_BASE } from '../config';

const VendorProductForm = ({ partnerId, onClose, onRefresh }) => {
  // 🔥 FIX: Key ko match karne ke liye 'IT_Infrastructure' kar diya hai
  const categoryMatrix = {
      'Mobility': ['Electronics', 'Home Appliances', 'Home & Garden', 'Baby & Kids', 'Beauty & Care'],
      'NCN': ['IT Products', 'Computers', 'Networking Hardware', 'Software Licenses', 'Peripherals'],
      'Imaging': ['Printer Cartridges', 'Toner Units', 'Photo Paper', 'Scanner Accessories'],
      'Refurbished': ['Refurbished Laptops', 'Refurbished Mobiles', 'Refurbished Printers', 'Certified Used Hardware'],
      'IT_Infrastructure': ['Servers & Racks', 'Enterprise Networking', 'Data Storage Solutions', 'Cabling & Accessories', 'Security & Surveillance']
  };

  const [formData, setFormData] = useState({
    Title: '', Description: '', SKU: '', Price: '', MOQ: '1', Stock: '',
    Vertical: 'Mobility', Megamenu_Heading: '', Sub_Category: '', Images: '',
    Best_Offer: 'No', Hot_products: 'No', Offer_Priority: '0'
  });

  const [hoveredVertical, setHoveredVertical] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payload = { 
      ...formData, 
      Vendor_ID: partnerId || 1  
    };
    
    console.log("Form Data Being Sent:", payload); 
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/api/partners/products/supply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.success) {
        setMessage('🎉 Product submitted to Admin approval pipeline!');
        setFormData({
          Title: '', Description: '', SKU: '', Price: '', MOQ: '1', Stock: '',
          Vertical: 'Mobility', Megamenu_Heading: '', Sub_Category: '', Images: '',
          Best_Offer: 'No', Hot_products: 'No', Offer_Priority: '0'
        });
        if (onRefresh) onRefresh();
      } else {
        setMessage(`❌ Error: ${data.message}`);
      }
    } catch (error) {
      setMessage('❌ Network Error: Server respond nahi kar raha hai.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vendor-form-overlay">
      <div className="vendor-form-header">
        <h3>📦 Supply New Product Details (B2B Catalog)</h3>
        <button onClick={onClose} className="vendor-close-btn">✖</button>
      </div>

      {message && (
        <div className={`vendor-alert-msg ${message.includes('🎉') ? 'vendor-alert-success' : 'vendor-alert-error'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="vendor-form-group vendor-vertical-wrapper">
          <label>Select Business Vertical *</label>
          <div style={{ position: 'relative' }}>
            <select 
              name="Vertical" 
              value={formData.Vertical} 
              onChange={handleChange}
              className="vendor-dropdown-select"
            >
              <option value="Mobility">Mobility</option>
              <option value="NCN">NCN</option>
              <option value="Imaging">Imaging</option>
              <option value="Refurbished">Refurbished</option>
              {/* Dropdown value match with categoryMatrix key */}
              <option value="IT_Infrastructure">IT Infrastructure & Innovation</option>
            </select>
            
            <div className="vendor-category-info-bar">
              <strong>💡 Categories Guide:</strong> Move mouse below to view sub-items mapping layout.
            </div>

            <div className="vendor-hover-triggers-row">
              {Object.keys(categoryMatrix).map((verticalKey) => (
                <div 
                  key={verticalKey}
                  className={`vendor-hover-pill ${formData.Vertical === verticalKey ? 'active' : ''}`}
                  onMouseEnter={() => setHoveredVertical(verticalKey)}
                  onMouseLeave={() => setHoveredVertical(null)}
                >
                  {/* Label ko readable banane ke liye formatting */}
                  🔍 Peek {verticalKey === 'IT_Infrastructure' ? 'IT Infrastructure' : verticalKey} Scope
                  
                  {hoveredVertical === verticalKey && (
                    <div className="vendor-floating-dropdown-scope">
                      <h5>Includes Products Related To:</h5>
                      <ul>
                        {categoryMatrix[verticalKey].map((item, index) => (
                          <li key={index}>⚡ {item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="vendor-form-group">
          <label>Product Title *</label>
          <input type="text" name="Title" value={formData.Title} onChange={handleChange} required placeholder="Example: HP Laserjet Pro M404dn" />
        </div>

        <div className="vendor-form-group">
          <label>Description</label>
          <textarea name="Description" value={formData.Description} onChange={handleChange} rows="3" placeholder="Enter specifications, dimensions etc..."></textarea>
        </div>

        <div className="vendor-form-row">
          <div className="vendor-flex-1 vendor-form-group">
            <label>SKU Code *</label>
            <input type="text" name="SKU" value={formData.SKU} onChange={handleChange} required placeholder="SKU-XYZ-009" />
          </div>
          <div className="vendor-flex-small vendor-form-group">
            <label>Price (₹) *</label>
            <input type="number" name="Price" value={formData.Price} onChange={handleChange} required placeholder="12000" />
          </div>
          <div className="vendor-flex-small vendor-form-group">
            <label>Stock Qty *</label>
            <input type="number" name="Stock" value={formData.Stock} onChange={handleChange} required placeholder="25" />
          </div>
          <div className="vendor-flex-small vendor-form-group">
            <label>MOQ (Min Order) *</label>
            <input type="number" name="MOQ" value={formData.MOQ} onChange={handleChange} required />
          </div>
        </div>

        <div className="vendor-form-row">
          <div className="vendor-flex-1 vendor-form-group">
            <label>Megamenu Heading *</label>
            <input type="text" name="Megamenu_Heading" value={formData.Megamenu_Heading} onChange={handleChange} required placeholder="e.g. IT Peripherals / Home Devices" />
          </div>
          <div className="vendor-flex-1 vendor-form-group">
            <label>Sub Category *</label>
            <input type="text" name="Sub_Category" value={formData.Sub_Category} onChange={handleChange} required placeholder="e.g. Toner Cartridges / Mobile Cases" />
          </div>
        </div>

        <div className="vendor-form-group">
          <label>Images URLs (Comma separated links)</label>
          <input type="text" name="Images" value={formData.Images} onChange={handleChange} placeholder="img1.png, img2.png" />
        </div>

        <div className="vendor-promo-section">
          <div className="vendor-promo-item vendor-form-group">
            <label>Best Offer?</label>
            <select name="Best_Offer" value={formData.Best_Offer} onChange={handleChange}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
          </div>
          <div className="vendor-promo-item vendor-form-group">
            <label>Hot Product?</label>
            <select name="Hot_products" value={formData.Hot_products} onChange={handleChange}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
          </div>
          <div className="vendor-promo-item vendor-form-group">
            <label>Offer Priority</label>
            <input type="number" name="Offer_Priority" value={formData.Offer_Priority} onChange={handleChange} style={{ width: '80px' }} />
          </div>
        </div>

        <button type="submit" disabled={loading} className="vendor-submit-btn">
          {loading ? 'Processing Catalog Registry...' : 'Send to Admin Approval Pipeline 🚀'}
        </button>
      </form>
    </div>
  );
};

export default VendorProductForm;